import { Link } from "react-router-dom";
import "./cardmultimedya.scss";
import { ICardResponse } from "../../../core/models";

export interface ICardMultimedyaProps {
  props?: ICardResponse;
}

const CardMultimedya = ({ props }: ICardMultimedyaProps) => {
  return (
    <Link
      to={{
        pathname: props?.detailUrl,
      }}
      className="card-multimedya"
    >
      <div className="card-multimedya__image">
        <img
          src={props?.listImage?.src}
          width={164}
          height={100}
          alt={props?.listImage?.alt}
          style={{ height: "auto", width: "100%" }}
        />
        <span className="icon icon-video"></span>
        <span className="icon icon-play"></span>
      </div>
      <div className="card-multimedya__text">
        <div className="date-container">
          <span className="date">{props?.dateAreaFormatted}</span>
          <span className="time ">{props?.readTime}</span>
          <img src={"/icons/clock.svg"} width={16} height={16} alt="clock" />
        </div>
        <span className="title">
          <strong>{props?.title}</strong>
        </span>
        <span className="icon icon-arrow-right"></span>
      </div>
    </Link>
  );
};

export default CardMultimedya;
